import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import React from 'react';
import { MobileHelpTooltipStlyes } from '../../styles/HelpToolTip';
import CloseIcon from '@material-ui/icons/Close';
import { AnswerLabel, HelpPageProps } from '../../interfaces/HelpToolTip';
import { useTranslation } from 'react-i18next';
import { getCleanLabels } from '../../utils/helper';
import { LayoutStyles } from '../../styles/mfsTheme';
import useHiddenHeaderFooter from '../../hooks/useHiddenHeaderFooter';

const MobileHelpTooltip = ({ hasNoEvidence, labels, open, setOpen, isPreview }: HelpPageProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = MobileHelpTooltipStlyes();
  const contClass = LayoutStyles();
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  useHiddenHeaderFooter(
    open && !smUp
      ? contClass.screenContainer
      : `${contClass.container} ${!isPreview ? '' : contClass.previewContainer}`,
  );

  const closeHelp = (): void => {
    setOpen(false);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.headingBox}>
        <Typography className={classes.headingText} variant="h4">
          {t('ratingScale')}
        </Typography>
        <IconButton className={classes.closeBtn} onClick={closeHelp} role="button" aria-label={t('close')}>
          <CloseIcon fontSize="large" className={classes.contrastColor} />
        </IconButton>
      </Box>

      <List dense={true}>
        {labels &&
          labels.map((label: AnswerLabel) => {
            return (
              <ListItem
                key={label.value}
                className={`${!hasNoEvidence && label.value === '0' ? classes.displayNone : ''}`}>
                <ListItemIcon>
                  <div className={classes.listIcon} aria-label={`Response option ${label.value}`} aria-required="true">
                    {label.value === '0' ? <BlockIcon className={classes.labelIcon} /> : label.value}
                  </div>
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      className={classes.contrastColor}
                      variant="h6"
                      aria-label={`Response option ${label.description}`}
                      aria-required="true">
                      {getCleanLabels(label.description)}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
      </List>

      <Box className={classes.closeBtnBox}>
        <Button className={classes.closeBtn2} onClick={closeHelp} variant="contained">
          {t('ok')}
        </Button>
      </Box>
    </Box>
  );
};

export default React.memo(MobileHelpTooltip);
